module.exports = __webpack_public_path__ + "img/sheker.8e8c150b.svg";